import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-305ee1bd"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "table"
};
import TakeCell from '@/components/take/take-cell.vue';
import MInfinite from '@/libs/infinite/index.vue';
import MWaterfall from '@/libs/waterfall/index.vue';
import composition from '@/composition';
export default {
  props: {
    order: String,
    cid: Number,
    tagId: String,
    type: String
  },

  setup(__props) {
    const props = __props;
    const {
      ref,
      request
    } = composition();
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    let page = 1;

    const onLoad = async () => {
      if (finished.value) return;

      if (list.value.length) {
        page += 1;
      }

      const res = await request.getPostList({
        categoryId: props.cid,
        order: props.order,
        tagId: props.tagId,
        page,
        pageSize: 8
      });

      if (page === 1) {
        list.value = res.data;
      } else {
        list.value.push(...res.data);
      }

      if (res.data.length == 0) {
        finished.value = true;
      }

      loading.value = false;
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MInfinite, {
        modelValue: loading.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loading.value = $event),
        isFinished: finished.value,
        onOnLoad: onLoad
      }, {
        default: _withCtx(() => [_createVNode(MWaterfall, {
          class: "content-wrap",
          name: __props.order,
          data: list.value,
          column: 2,
          columnSpacing: 7,
          rowSpacing: 8,
          picturePreReading: false
        }, {
          default: _withCtx(({
            item
          }) => [_createVNode(TakeCell, {
            item: item
          }, null, 8, ["item"])]),
          _: 1
        }, 8, ["name", "data"])]),
        _: 1
      }, 8, ["modelValue", "isFinished"])]);
    };
  }

};